module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"ZennHRBSB","short_name":"ZennHRB","start_url":"/","background_color":"#1B75BC","theme_color":"#424B54","display":"standalone","icon":"src/assets/images/logo.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"25e9f1921d5b7ebe5ca244eb4731d560"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
